
import {Component, Vue} from 'vue-property-decorator';
import NevronHeader from '@/components/NevronHeader.vue';
import stores from '../../stores';
import Skeleton from '@/modules/Skeleton.vue';
// @ts-ignore
import Switches from 'vue-switches';
import {Setting} from "@/stores/Setting";
import {hasPermission} from "@/helpers/permissions";
import {translate} from '@/helpers/functions';

@Component({
  components: {
    NevronHeader,
    Skeleton,
    Switches,
  },
})

export default class UserSettings extends Vue {
  // Settings variables with improved naming
  accountEnabled: ISetting = { key: 'account_enabled', value: false };
  requestCheckoutEmail: ISetting = { key: 'request_checkout_email', value: '' };
  requestCheckoutSwitch: ISetting = { key: 'request_checkout', value: false };
  interestEnabled: ISetting = { key: 'interest_enabled', value: false };
  surveyEnabled: ISetting = { key: 'survey', value: false };
  messagesEnabled: ISetting = { key: 'message_enabled', value: false };
  viewBillEnabled: ISetting = { key: 'view_bill', value: false };
  castingEnabled: ISetting = { key: 'casting', value: false };
  languageEnabled: ISetting = { key: 'language_enabled', value: false };
  changePinEnabled: ISetting = { key: 'change_pin_enabled', value: false };
  dateTimeEnabled: ISetting = { key: 'date_time_enabled', value: false };
  clearMyDataEnabled: ISetting = { key: 'clear_my_data_enabled', value: false };
  searchEnabled: ISetting = { key: 'iptv_search', value: false };
  timeEnabled: ISetting = { key: 'iptv_time', value: false };
  weatherEnabled: ISetting = { key: 'iptv_weather', value: false };

  // Expose translate and hasPermission for template
  get translate() {
    return translate;
  }
  get hasPermission() {
    return hasPermission;
  }

  /**
   * Called when changes need to re-render
   */
  mounted() {
    Vue.prototype.WebsiteTitle.setModuleName('payment-configuration');
    this.fetchSettings();
  }

  fetchSettings() {
    stores.Setting.getSettings().then((data: ISetting[]) => {
      for (const setting of data) {
        switch (setting.key) {
          case 'iptv_search':
            this.searchEnabled = setting;
            this.searchEnabled.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
          case 'iptv_time':
            this.timeEnabled = setting;
            this.timeEnabled.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
          case 'iptv_weather':
            this.weatherEnabled = setting;
            this.weatherEnabled.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
          case 'account_enabled':
            this.accountEnabled = setting;
            this.accountEnabled.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
          case 'interest_enabled':
            this.interestEnabled = setting;
            this.interestEnabled.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
          case 'survey':
            this.surveyEnabled = setting;
            this.surveyEnabled.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
          case 'message_enabled':
            this.messagesEnabled = setting;
            this.messagesEnabled.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
          case 'view_bill':
            this.viewBillEnabled = setting;
            this.viewBillEnabled.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
          case 'casting':
            this.castingEnabled = setting;
            this.castingEnabled.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
          case 'language_enabled':
            this.languageEnabled = setting;
            this.languageEnabled.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
          case 'change_pin_enabled':
            this.changePinEnabled = setting;
            this.changePinEnabled.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
          case 'date_time_enabled':
            this.dateTimeEnabled = setting;
            this.dateTimeEnabled.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
          case 'clear_my_data_enabled':
            this.clearMyDataEnabled = setting;
            this.clearMyDataEnabled.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
          case 'request_checkout_email':
            this.requestCheckoutEmail = { ...setting };
            break;
          case 'request_checkout':
            this.requestCheckoutSwitch = setting;
            this.requestCheckoutSwitch.value = setting.value === true || setting.value === 1 || setting.value === '1';
            break;
        }
      }
    });
  }

  isValidEmail(email: string): boolean {
    if(email == "") {
      return true;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  onSubmit(id: number, value: ISetting) {
    if (!id || isNaN(id)) return;
    if (this.isValidEmail(this.requestCheckoutEmail.value as string)) {
      stores.Setting.update(id, { value }).then(() => {
        this.fetchSettings();
        console.log('setting updated successfully..');
      });
    } else {
      console.log(this.requestCheckoutEmail.value + ' is not valid');
    }
  }
  updateMultiple() {
    const array = [this.requestCheckoutSwitch, this.requestCheckoutEmail, this.accountEnabled];
    for (const item of array) {
      const idAsNumber = Number(item.id);
      if (!isNaN(idAsNumber)) {
        this.onSubmit(idAsNumber, item);
      }
    }
  }
}
